import React from "react"
import PropTypes from "prop-types"

const Search = ({ fillColor }) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20_142)">
      <path
        d="M1.65211 7.2857C1.65211 10.8624 4.61089 13.7619 8.26081 13.7619C11.9107 13.7619 14.8695 10.8624 14.8695 7.2857C14.8695 3.709 11.9107 0.809509 8.26081 0.809509C4.61089 0.809509 1.65211 3.709 1.65211 7.2857Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M13.5272 11.6369L18.174 16.1905"
        stroke="black"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_20_142">
        <rect
          width="19"
          height="17"
          fill="white"
          transform="matrix(-1 0 0 1 19 0)"
        />
      </clipPath>
    </defs>
  </svg>
)

Search.propsTypes = {
  fillColor: PropTypes.string,
}

Search.defaultProps = {
  fillColor: "currentColor",
}

export { Search }
